// This values is from the ".env" file
const version = process.env.REACT_APP_VERSION;

function Version() {
  const strVersion = version?.startsWith('v') ? version : `v${version}`;
  return strVersion;
}

export default Version;
